import { render, staticRenderFns } from "./TabelaAnexos.vue?vue&type=template&id=7439dfc0&scoped=true"
import script from "./TabelaAnexos.vue?vue&type=script&lang=js"
export * from "./TabelaAnexos.vue?vue&type=script&lang=js"
import style0 from "./TabelaAnexos.vue?vue&type=style&index=0&id=7439dfc0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7439dfc0",
  null
  
)

export default component.exports